import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute, Params } from "@angular/router";
import { DrawerModule } from "primeng/drawer";
import { ClientContact } from "../../../../core/models/client/details/clientContact";
import { ClientAddressCustomize } from "../../../../core/models/client/details/clientAddresscustomize";
import { LoaderService } from "../../../../core/services/loader.service";
import { ClientPurposeType } from "../../../../shared/enums/clientpurposetype";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { CommonModule } from "@angular/common";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ClientDetailsService } from "../../../../core/services/client-details.service";
import { ClientDto } from "../../../../core/models/client/details/clientDto";

@UntilDestroy()
@Component({
  selector: "jni-view-contact-information",
  templateUrl: "./view-contact-information.component.html",
  imports: [CommonModule, DrawerModule],
  styleUrls: ["./view-contact-information.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ViewContactInformationComponent implements OnInit {
  @Input() display!: boolean;
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() editEvent = new EventEmitter<ClientAddressCustomize>();
  @Output() refreshGrid = new EventEmitter<boolean>();
  // @Input() clientIdFromModal = '';

  clientId = "";

  salesOrderIdList: string[] = [];

  clientContactInformation?: ClientContact[] = [];
  ClientAddresses: ClientAddressCustomize[] = [];
  clientType = "";

  clientInformation?: ClientDto;
  postingDate: Date = new Date();

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("clientIdFromModal")
  set clientIdFromModal(value: string) {
    this.clientId = value;
  }

  constructor(
    private _loaderService: LoaderService,
    private _clientDetailsService: ClientDetailsService,
    private router: ActivatedRoute,
    private _toastr: JniToastrService
  ) {
    this.router.params.subscribe((params: Params) => {
      this.clientId = params["id"];
    });
  }

  ngOnInit(): void {
    this.getClientInformationData();
  }

  onHide() {
    this.displayChange.emit(false);
  }

  getClientInformationData() {
    if (this.clientId) {
      this._loaderService.setLoaderState(true);
      this._clientDetailsService
        .getClientInformation(this.clientId?.toString())
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.ClientAddresses = [];
              this.clientInformation = res.data;
              this.clientContactInformation = res.data.clientContacts;
              this.clientType =
                (
                  this.clientInformation!.client!.clientType as string
                ).toLowerCase() ?? "";
              this.transformClientContactData();
            }
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  transformClientContactData() {
    if (this.clientType?.toLowerCase() === "client") {
      const Business = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Business
      );
      this.populateClientContactInformation(Business);
      const Invoice = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Invoice
      );
      this.populateClientContactInformation(Invoice);

      const Payment = this.clientContactInformation?.filter(
        x =>
          (x.purposeD365! as string).toLowerCase() == "payable" ||
          x.purposeD365 == ClientPurposeType.Payment
      );
      this.populateClientContactInformation(Payment);
      const Delivery = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Delivery
      );
      this.populateClientContactInformation(Delivery);
      const Other = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Other
      );
      this.populateClientContactInformation(Other);
      const Buyer = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Buyer
      );
      this.populateClientContactInformation(Buyer);
    } else if (this.clientType?.toLowerCase() === "prospect") {
      const Business = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Business
      );
      this.populateClientContactInformation(Business);
      const Invoice = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Invoice
      );
      this.populateClientContactInformation(Invoice);

      const Payment = this.clientContactInformation?.filter(
        x =>
          (x.purposeD365! as string).toLowerCase() == "payable" ||
          x.purposeD365 == ClientPurposeType.Payment
      );
      this.populateClientContactInformation(Payment);
      const Delivery = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Delivery
      );
      this.populateClientContactInformation(Delivery);
      const Other = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Other
      );
      this.populateClientContactInformation(Other);
      const Buyer = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Buyer
      );
      this.populateClientContactInformation(Buyer);
    }
  }

  populateClientContactInformation(
    clientContacts: ClientContact[] | undefined
  ) {
    if (
      clientContacts != null &&
      clientContacts != undefined &&
      clientContacts.length > 0
    ) {
      const clientAddress: ClientAddressCustomize = {};
      clientAddress.purpose = clientContacts[0].purposeD365;
      clientAddress.isPrimary = clientContacts[0].isPrimaryD365;
      clientAddress.name = clientContacts[0].descriptionD365;
      clientAddress.cust = clientContacts[0].cust;
      clientAddress.title = clientContacts[0].title;

      // clientAddress.electronicAddressIdD365 =
      //   clientContacts[0].electronicAddressIdD365;

      if (
        clientContacts.find(x => x.typeD365 == EnumContactType.Phone) !=
        undefined
      ) {
        clientAddress.phone = clientContacts.find(
          x => x.typeD365 == EnumContactType.Phone
        )?.locatorD365;
        clientAddress.phoneLink =
          "tel:'" +
          clientContacts.find(x => x.typeD365 == EnumContactType.Phone)
            ?.locatorD365 +
          "'";
        if (this.clientType?.toLowerCase() === "client") {
          clientAddress.electronicAddressPhone = clientContacts.find(
            x => x.typeD365 == EnumContactType.Phone
          )?.electronicAddressIdD365;
        } else if (this.clientType?.toLowerCase() === "prospect") {
          clientAddress.electronicAddressPhone = clientContacts.find(
            x =>
              x.typeD365 == EnumContactType.Phone &&
              x.electronicAddressIdD365 !== ""
          )?.electronicAddressIdD365;
        }
      }
      if (
        clientContacts.find(x => x.typeD365 == EnumContactType.Email) !=
        undefined
      ) {
        clientAddress.email = clientContacts.find(
          x => x.typeD365 == EnumContactType.Email
        )?.locatorD365;
        clientAddress.emailLink =
          "mailto:'" +
          clientContacts.find(x => x.typeD365 == EnumContactType.Email)
            ?.locatorD365 +
          "'";
        clientAddress.electronicAddressEmail = clientContacts.find(
          x => x.typeD365 == EnumContactType.Email
        )?.electronicAddressIdD365;

        if (this.clientType?.toLowerCase() === "client") {
          clientAddress.electronicAddressEmail = clientContacts.find(
            x => x.typeD365 == EnumContactType.Email
          )?.electronicAddressIdD365;
        } else if (this.clientType?.toLowerCase() === "prospect") {
          clientAddress.electronicAddressEmail = clientContacts.find(
            x =>
              x.typeD365 == EnumContactType.Email &&
              x.electronicAddressIdD365 !== ""
          )?.electronicAddressIdD365;
        }
      }

      this.ClientAddresses.push(clientAddress);
    }
  }

  openEditContact(event: ClientAddressCustomize) {
    this.editEvent.emit(event);
  }

  deleteCustomerContact(item: ClientAddressCustomize) {
    this._loaderService.setLoaderState(true);

    const contactList = [];
    if (item?.electronicAddressPhone) {
      contactList.push(item.electronicAddressPhone);
    }
    if (item?.electronicAddressEmail) {
      contactList.push(item.electronicAddressEmail);
    }

    this._clientDetailsService
      .deleteCustomerContact(contactList)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            this._toastr.success(
              "Success",
              res.message || "Contact deleted successfully"
            );
            this.getClientInformationData();
            this.refreshGrid.emit(true);
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error deleting contact"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error deleting contact");
        },
      });
  }
}
